<template>
  <vonap-promised :promise="promise">
    <div>
      <page-toolbar>
        <kendo-dropdownlist
          ref="datesDropDown"
          :dataSource="dashboardScenarioDataSource"
          :dataValueField="'scenarioId'"
          :dataTextField="'scenarioName'"
          :index="0"
          style="width: 250px"
          @change="controlChanged"
          @databound="scenarioDropdownBound"
        />
        <v-btn
          color="warning"
          small
          fab
          flat
          @click="downloadZip"
          v-show="!rendering"
          title="Download all files"
        >
          <v-icon>far fa-file-archive</v-icon>
        </v-btn>

        <kendo-button type="button" v-show="false" title="Test send email" @click="sendEmail">
          <i class="fas fa-envelope-square"></i>
        </kendo-button>
        <v-progress-circular
          color="primary"
          :size="30"
          :width="3"
          :indeterminate="true"
          v-if="rendering"
        ></v-progress-circular>
      </page-toolbar>

      <kendo-grid
        ref="grid"
        :autoBind="false"
        :dataSource="dataSource"
        :filterable="true"
        :sortable="true"
        :pageable-always-visible="false"
        :columns="columns"
      >
      </kendo-grid>
    </div>
  </vonap-promised>
</template>
<script>
import eventBus from '@/helpers/event-bus'
import axios from 'axios'
import {mapGetters} from 'vuex'
import params from '@/helpers/params'
import notification from '@/helpers/notification'
import security from '@/mixins/security'
import PageToolbar from '@/components/PageToolbar'
import VonapPromised from '@/components/VonapPromised'

export default {
  name: 'DashboardFiles',
  props: {
    incomingScenarioId: {
      type: Number,
      default: null,
    },
  },
  mixins: [security],
  components: {
    PageToolbar,
    VonapPromised,
  },
  data() {
    return {
      showFileUploadDialog: true,
      importMessage: '',
      toDate: null,
      selectedScenario: null,
      dashboardScenarios: {},
      rendering: false,
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    promise() {
      return this.getData()
    },
    importUrl() {
      return '/api/azureStorage/uploadFiles?clientId=' + this.selectedClientId
    },
    isMaster() {
      return this.clientId == 0
    },
    canEdit() {
      return ['SuperAdmin', 'Admin'].includes(this.currentRole)
    },
    isReadOnly() {
      return !this.canEdit && this.isMaster
    },
    grid() {
      return this.$refs.grid
    },
    datesDropDown() {
      return kendo.jQuery(this.$refs.datesDropDown)
    },
    columns() {
      return [
        {
          field: 'fileName',
          title: 'Filename',
          template: '<a href="#=uri#" class="downloadFileLink" target="_blank">#=fileName#</a>',
          width: 180,
          attributes: {style: 'text-align: left;', class: 'azureFile'},
        },
        {
          field: 'clientName',
          title: 'Client',
          width: 150,
        },
        {
          field: 'responsible',
          title: 'Responsible',
          width: 150,
        },
        {
          field: 'lastModified',
          title: 'Created On',
          format: '{0:yyyy-MM-dd HH:mm:ss}',
          width: 120,
        },
        {command: 'destroy', title: '&nbsp;', width: 60, hidden: true},
      ]
    },

    dashboardScenarioDataSource() {
      return new kendo.data.DataSource({
        data: this.dashboardScenarios,
      })
    },
    dataSource() {
      return new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: false,
        serverFiltering: false,
        serverSorting: false,
        transport: {
          read: {
            type: 'GET',
            url: '/api/azureStorage/getDashboardFiles',
            data: {
              dashboardScenarioId: this.selectedScenario,
            },
            dataType: 'json',
          },
        },
        requestEnd: e => {
          if (e.type != 'read') {
            this.$emit('success')
          }
        },
        batch: false,
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'fileId',
            fields: {
              fileId: {type: 'number'},
              fileName: {type: 'string'},
              username: {type: 'string'},
              clientName: {type: 'string'},
              responsible: {type: 'string'},
              lastModified: {type: 'date'},
            },
          },
        },
        error: function() {
          //let grid = $('#contractGrid').data('kendoGrid')
          //grid.one('dataBinding', e => {
          //  e.preventDefault()
          //})
        },
      })
    },
  },
  methods: {
    refreshGrid() {
      this.dataSource.read()
    },
    downloadZip() {
      this.rendering = true

      const qs = params.fromObject({
        t: this.tokenString,
        dashboardScenarioId: this.selectedScenario,
      })
      location.href = `/api/azureStorage/downloadZip?${qs}`
      setTimeout(() => {
        this.rendering = false
      }, 6000)
    },
    async sendEmail() {
      const qs = params.fromObject({
        t: this.tokenString,
        dashboardScenarioId: this.selectedScenario,
      })
      const url = `/api/config/dashboardScenario/processScenario?${qs}`

      await axios
        .post(url)
        .then(function() {
          notification('check your email', 'info')
        })
        .catch(() => notification('Error ', 'error'))
    },
    async getData() {
      const qs = params.fromObject({
        t: this.tokenString,
        dashboardScenarioId: this.incomingScenarioId == null ? 0 : this.incomingScenarioId,
      })
      const getAvailableUrl = `/api/azureStorage/getAvailableDashboardScenarios?${qs}`

      const req = await axios.get(getAvailableUrl).catch(() => notification('Error ', 'error'))
      let data = req.data
      this.dashboardScenarios = data
    },
    controlChanged(e) {
      this.selectedScenario = e.sender.value()
      this.refreshGrid()
    },
    scenarioDropdownBound(e) {
      this.selectedScenario = e.sender.value()
      this.refreshGrid()
    },
    hideImportDialog() {
      this.showFileUploadDialog = false
      this.importMessage = ''
    },
    onError() {
      notification('Error importing the file', 'error')
    },
    onSuccess(e) {
      if (e.status == 0) {
        notification(e.message, 'info')
        this.refreshGrid()
        this.$emit('success')
        //this.hideImportDialog()
        this.importMessage = ''
      } else {
        notification(e.message, 'error')
        this.importMessage = e.message
      }
      eventBus.$emit('doReset', {foo: 'bar'})
    },
  },
}
</script>
<style>
.azureFile {
  text-decoration: underline !important;
}
.azureFile:hover {
  cursor: pointer;
}
</style>
